// ui/form/elements/Switch.tsx
import * as React from "react"
import clx from "classnames"

export interface SwitchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {}

/**
 * Minimal switch toggle — supports ref, disabled, readOnly.
 */
export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className = "", readOnly, disabled, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type="checkbox"
        disabled={disabled}
        readOnly={readOnly}
        className={clx(
          // base
          "tw-relative tw-appearance-none tw-h-5 tw-w-9 tw-rounded-full tw-cursor-pointer tw-transition-colors tw-duration-200",
          // track
          "tw-bg-gray-300 dark:tw-bg-gray-700",
          // thumb (using pseudo-element)
          "before:tw-content-[''] before:tw-absolute before:tw-top-0.5 before:tw-left-0.5",
          "before:tw-h-4 before:tw-w-4 before:tw-rounded-full",
          "before:tw-bg-white before:tw-shadow before:tw-transition-all before:tw-duration-200",

          // checked state
          "checked:tw-bg-blue-500 checked:dark:tw-bg-blue-600",
          "checked:before:tw-translate-x-4",

          // disabled
          disabled &&
            "tw-opacity-50 tw-cursor-not-allowed checked:tw-bg-blue-400 dark:checked:tw-bg-blue-500",

          className
        )}
        {...props}
      />
    )
  }
)

Switch.displayName = "Switch"
